import '../../../styles/Header.scss';
import { NavLink, useLocation } from "react-router-dom";
import { useState } from "react";

function SafariLogo() {
    return (
        <svg
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            width="780"
            height="186"
            viewBox="0 0 780 186"
        >
            <defs>
                <clipPath id="clip-path">
                    <path
                        id="Path_270"
                        data-name="Path 270"
                        d="M0,0V186L780,.051Z"
                        fill="none"
                    />
                </clipPath>
            </defs>

            <g id="Group_124" data-name="Group 124">
                <path
                    id="base_color"
                    data-name="base color"
                    d="M780,.74,0,186.689V.74"
                    transform="translate(0 -0.689)"
                    fill="#1a1a1a"
                />

                <g
                    id="Group_123"
                    data-name="Group 123"
                    clip-path="url(#clip-path)"
                >
                    <g
                        id="Group_122"
                        data-name="Group 122"
                        transform="translate(-109.185 -728.509)"
                    >
                        <g id="Group_120" data-name="Group 120">

                            <g
                                id="Group_106"
                                data-name="Group 106"
                                transform="translate(130.072 195.509)"
                            >
                                <path
                                    id="Path_233"
                                    data-name="Path 233"
                                    d="M303.666-7095.041a1.292,1.292,0,0,0,.816.29,1.291,1.291,0,0,0,1-.476l530.48-651.2a1.292,1.292,0,0,0-.187-1.818,1.3,1.3,0,0,0-1.821.187l-530.48,651.2a1.292,1.292,0,0,0,.187,1.818Z"
                                    transform="translate(-303.189 7748.539)"
                                    fill="none"
                                />
                                <path
                                    id="Path_234"
                                    data-name="Path 234"
                                    d="M303.666-7095.041a1.292,1.292,0,0,0,.816.29,1.291,1.291,0,0,0,1-.476l530.48-651.2a1.292,1.292,0,0,0-.187-1.818,1.3,1.3,0,0,0-1.821.187l-530.48,651.2a1.292,1.292,0,0,0,.187,1.818Z"
                                    transform="translate(-303.189 7748.539)"
                                    fill="#ffd100"
                                />
                            </g>

                            <g
                                id="Group_107"
                                data-name="Group 107"
                                transform="translate(138.197 831.184)"
                            >
                                <path
                                    id="Path_235"
                                    data-name="Path 235"
                                    d="M445.664,1494.8a6.487,6.487,0,0,1,.552-1.57c.036-.195.086-.387.141-.581l-24.818,23.414a1.293,1.293,0,0,0,1.777,1.877l21.8-20.567a11.542,11.542,0,0,1,.358-1.755l.19-.821Z"
                                    transform="translate(-421.134 -1492.65)"
                                    fill="none"
                                />
                                <path
                                    id="Path_236"
                                    data-name="Path 236"
                                    d="M445.664,1494.8a6.487,6.487,0,0,1,.552-1.57c.036-.195.086-.387.141-.581l-24.818,23.414a1.293,1.293,0,0,0,1.777,1.877l21.8-20.567a11.542,11.542,0,0,1,.358-1.755l.19-.821Z"
                                    transform="translate(-421.134 -1492.65)"
                                    fill="#ffd100"
                                />
                            </g>

                            <g
                                id="Group_108"
                                data-name="Group 108"
                                transform="translate(176.971 277.75)"
                            >
                                <path
                                    id="Path_237"
                                    data-name="Path 237"
                                    d="M984.222-6012.359a4.4,4.4,0,0,1,.9-.25,10.578,10.578,0,0,0,1.5-.36,12.057,12.057,0,0,1,2.312-.459l569.507-537.283a1.292,1.292,0,0,0,.052-1.827,1.294,1.294,0,0,0-1.83-.052l-572.7,540.3C984.046-6012.313,984.138-6012.345,984.222-6012.359Z"
                                    transform="translate(-983.96 6552.944)"
                                    fill="none"
                                />
                                <path
                                    id="Path_238"
                                    data-name="Path 238"
                                    d="M984.222-6012.359a4.4,4.4,0,0,1,.9-.25,10.578,10.578,0,0,0,1.5-.36,12.057,12.057,0,0,1,2.312-.459l569.507-537.283a1.292,1.292,0,0,0,.052-1.827,1.294,1.294,0,0,0-1.83-.052l-572.7,540.3C984.046-6012.313,984.138-6012.345,984.222-6012.359Z"
                                    transform="translate(-983.96 6552.944)"
                                    fill="#ffd100"
                                />
                            </g>

                            <g
                                id="Group_109"
                                data-name="Group 109"
                                transform="translate(219.625 370.852)"
                            >
                                <path
                                    id="Path_239"
                                    data-name="Path 239"
                                    d="M1605.591-4759.2l606.427-437.923a1.291,1.291,0,0,0,.291-1.8,1.294,1.294,0,0,0-1.806-.29L1603.12-4760.6A5.5,5.5,0,0,1,1605.591-4759.2Z"
                                    transform="translate(-1603.12 5199.462)"
                                    fill="none"
                                />
                                <path
                                    id="Path_240"
                                    data-name="Path 240"
                                    d="M1605.591-4759.2l606.427-437.923a1.291,1.291,0,0,0,.291-1.8,1.294,1.294,0,0,0-1.806-.29L1603.12-4760.6A5.5,5.5,0,0,1,1605.591-4759.2Z"
                                    transform="translate(-1603.12 5199.462)"
                                    fill="#ffd100"
                                />
                            </g>

                            <g
                                id="Group_110"
                                data-name="Group 110"
                                transform="translate(100.834 26.934)"
                            >
                                <path
                                    id="Path_241"
                                    data-name="Path 241"
                                    d="M-120.3-9392.34a1.319,1.319,0,0,0,.371.054,1.294,1.294,0,0,0,1.239-.922l240.522-804.335a1.29,1.29,0,0,0-.869-1.607,1.29,1.29,0,0,0-1.61.867l-240.522,804.335A1.292,1.292,0,0,0-120.3-9392.34Z"
                                    transform="translate(121.221 10199.206)"
                                    fill="none"
                                />
                                <path
                                    id="Path_242"
                                    data-name="Path 242"
                                    d="M-120.3-9392.34a1.319,1.319,0,0,0,.371.054,1.294,1.294,0,0,0,1.239-.922l240.522-804.335a1.29,1.29,0,0,0-.869-1.607,1.29,1.29,0,0,0-1.61.867l-240.522,804.335A1.292,1.292,0,0,0-120.3-9392.34Z"
                                    transform="translate(121.221 10199.206)"
                                    fill="#ffd100"
                                />
                            </g>

                            <g
                                id="Group_111"
                                data-name="Group 111"
                                transform="translate(308.774 473.218)"
                            >
                                <path
                                    id="Path_243"
                                    data-name="Path 243"
                                    d="M2897.443-3396.9l.639-.154c-.014-.007.056-.036.148-.083a4.476,4.476,0,0,1,.888-.323,9.65,9.65,0,0,1,1.318-.2,5.416,5.416,0,0,1,.586-.177,4.357,4.357,0,0,1,1.776-.057,7.236,7.236,0,0,1,1.1.063c.186,0,.341.016.512.023l576.772-311.072a1.291,1.291,0,0,0,.523-1.75,1.3,1.3,0,0,0-1.753-.523L2897.2-3396.861c.082-.011.16-.031.242-.039Z"
                                    transform="translate(-2897.2 3711.311)"
                                    fill="none"
                                />
                                <path
                                    id="Path_244"
                                    data-name="Path 244"
                                    d="M2897.443-3396.9l.639-.154c-.014-.007.056-.036.148-.083a4.476,4.476,0,0,1,.888-.323,9.65,9.65,0,0,1,1.318-.2,5.416,5.416,0,0,1,.586-.177,4.357,4.357,0,0,1,1.776-.057,7.236,7.236,0,0,1,1.1.063c.186,0,.341.016.512.023l576.772-311.072a1.291,1.291,0,0,0,.523-1.75,1.3,1.3,0,0,0-1.753-.523L2897.2-3396.861c.082-.011.16-.031.242-.039Z"
                                    transform="translate(-2897.2 3711.311)"
                                    fill="#ffd100"
                                />
                            </g>

                            <g
                                id="Group_112"
                                data-name="Group 112"
                                transform="translate(111.228 69.017)"
                            >
                                <path
                                    id="Path_245"
                                    data-name="Path 245"
                                    d="M30.421-8818.842a1.312,1.312,0,0,0,.528.111,1.294,1.294,0,0,0,1.181-.764L375.739-9585.6a1.292,1.292,0,0,0-.652-1.708,1.294,1.294,0,0,0-1.71.652L29.768-8820.55A1.292,1.292,0,0,0,30.421-8818.842Z"
                                    transform="translate(-29.655 9587.423)"
                                    fill="none"
                                />
                                <path
                                    id="Path_246"
                                    data-name="Path 246"
                                    d="M30.421-8818.842a1.312,1.312,0,0,0,.528.111,1.294,1.294,0,0,0,1.181-.764L375.739-9585.6a1.292,1.292,0,0,0-.652-1.708,1.294,1.294,0,0,0-1.71.652L29.768-8820.55A1.292,1.292,0,0,0,30.421-8818.842Z"
                                    transform="translate(-29.655 9587.423)"
                                    fill="#ffd100"
                                />
                            </g>

                            <g
                                id="Group_113"
                                data-name="Group 113"
                                transform="translate(121.031 125.532)"
                            >
                                <path
                                    id="Path_247"
                                    data-name="Path 247"
                                    d="M172.563-8048.66a1.281,1.281,0,0,0,.677.191,1.291,1.291,0,0,0,1.1-.613l440.816-714.772a1.288,1.288,0,0,0-.423-1.775,1.3,1.3,0,0,0-1.78.42L172.14-8050.437A1.29,1.29,0,0,0,172.563-8048.66Z"
                                    transform="translate(-171.947 8765.821)"
                                    fill="none"
                                />
                                <path
                                    id="Path_248"
                                    data-name="Path 248"
                                    d="M172.563-8048.66a1.281,1.281,0,0,0,.677.191,1.291,1.291,0,0,0,1.1-.613l440.816-714.772a1.288,1.288,0,0,0-.423-1.775,1.3,1.3,0,0,0-1.78.42L172.14-8050.437A1.29,1.29,0,0,0,172.563-8048.66Z"
                                    transform="translate(-171.947 8765.821)"
                                    fill="#ffd100"
                                />
                            </g>

                            <g
                                id="Group_114"
                                data-name="Group 114"
                                transform="translate(345.902 583.101)"
                            >
                                <path
                                    id="Path_249"
                                    data-name="Path 249"
                                    d="M3436.311-1886.163a8.224,8.224,0,0,1-.169,1.661c0,.157,0,.333,0,.506l597.137-227.388a1.292,1.292,0,0,0,.749-1.667,1.3,1.3,0,0,0-1.67-.747l-596.094,226.99A4.922,4.922,0,0,1,3436.311-1886.163Z"
                                    transform="translate(-3436.14 2113.884)"
                                    fill="none"
                                />
                                <path
                                    id="Path_250"
                                    data-name="Path 250"
                                    d="M3436.311-1886.163a8.224,8.224,0,0,1-.169,1.661c0,.157,0,.333,0,.506l597.137-227.388a1.292,1.292,0,0,0,.749-1.667,1.3,1.3,0,0,0-1.67-.747l-596.094,226.99A4.922,4.922,0,0,1,3436.311-1886.163Z"
                                    transform="translate(-3436.14 2113.884)"
                                    fill="#ffd100"
                                />
                            </g>

                            <path
                                id="Path_251"
                                data-name="Path 251"
                                d="M-277.04-9759.388a1.349,1.349,0,0,0,.207.015,1.293,1.293,0,0,0,1.277-1.087l133.32-828.8a1.293,1.293,0,0,0-1.072-1.481,1.293,1.293,0,0,0-1.483,1.07l-133.321,828.8a1.294,1.294,0,0,0,1.072,1.481Z"
                                transform="translate(368.154 10590.76)"
                                fill="#ffd100"
                            />

                            <g
                                id="Group_115"
                                data-name="Group 115"
                                transform="translate(0 836.565)"
                            >
                                <path
                                    id="Path_252"
                                    data-name="Path 252"
                                    d="M-1525.471,1572.976a76.778,76.778,0,0,0-47.934,34.615,76.574,76.574,0,0,0-9.381,58.321,2.872,2.872,0,0,0,2.792,2.2,2.876,2.876,0,0,0,.667-.078l144.8-34.379a2.873,2.873,0,0,0,1.782-1.286,2.868,2.868,0,0,0,.348-2.168A77.382,77.382,0,0,0-1525.471,1572.976Z"
                                    transform="translate(1584.913 -1570.872)"
                                    fill="none"
                                />
                                <path
                                    id="Path_253"
                                    data-name="Path 253"
                                    d="M-1525.471,1572.976a76.778,76.778,0,0,0-47.934,34.615,76.574,76.574,0,0,0-9.381,58.321,2.872,2.872,0,0,0,2.792,2.2,2.876,2.876,0,0,0,.667-.078l144.8-34.379a2.873,2.873,0,0,0,1.782-1.286,2.868,2.868,0,0,0,.348-2.168A77.382,77.382,0,0,0-1525.471,1572.976Z"
                                    transform="translate(1584.913 -1570.872)"
                                    fill="#ffd100"
                                />
                            </g>

                            <g
                                id="Group_116"
                                data-name="Group 116"
                                transform="translate(155.784 879.599)"
                            >
                                <path
                                    id="Path_254"
                                    data-name="Path 254"
                                    d="M685.286,2197.885a11.313,11.313,0,0,1-.768-1.125c-.061-.088-.109-.188-.166-.28l-7.094,2.7a1.292,1.292,0,0,0,.461,2.5,1.305,1.305,0,0,0,.461-.085l7.711-2.936-.606-.775Z"
                                    transform="translate(-676.425 -2196.48)"
                                    fill="none"
                                />
                                <path
                                    id="Path_255"
                                    data-name="Path 255"
                                    d="M685.286,2197.885a11.313,11.313,0,0,1-.768-1.125c-.061-.088-.109-.188-.166-.28l-7.094,2.7a1.292,1.292,0,0,0,.461,2.5,1.305,1.305,0,0,0,.461-.085l7.711-2.936-.606-.775Z"
                                    transform="translate(-676.425 -2196.48)"
                                    fill="#ffd100"
                                />
                            </g>

                            <g
                                id="Group_117"
                                data-name="Group 117"
                                transform="translate(159.049 698.609)"
                            >
                                <path
                                    id="Path_256"
                                    data-name="Path 256"
                                    d="M1544.246-433.685a1.294,1.294,0,0,0-1.558-.958L724.807-240.46a1.292,1.292,0,0,0-.959,1.557,1.294,1.294,0,0,0,1.257.994,1.377,1.377,0,0,0,.3-.035l817.88-194.184A1.292,1.292,0,0,0,1544.246-433.685Z"
                                    transform="translate(-723.813 434.678)"
                                    fill="none"
                                />
                                <path
                                    id="Path_257"
                                    data-name="Path 257"
                                    d="M1544.246-433.685a1.294,1.294,0,0,0-1.558-.958L724.807-240.46a1.292,1.292,0,0,0-.959,1.557,1.294,1.294,0,0,0,1.257.994,1.377,1.377,0,0,0,.3-.035l817.88-194.184A1.292,1.292,0,0,0,1544.246-433.685Z"
                                    transform="translate(-723.813 434.678)"
                                    fill="#ffd100"
                                />
                            </g>

                            {/*<path*/}
                            {/*    id="Path_258"*/}
                            {/*    data-name="Path 258"*/}
                            {/*    d="M1544.246,553.445a1.294,1.294,0,0,0-1.558-.958L724.807,746.67a1.293,1.293,0,0,0,.3,2.551,1.38,1.38,0,0,0,.3-.035L1543.287,555A1.292,1.292,0,0,0,1544.246,553.445Z"*/}
                            {/*    transform="translate(-564.764 214.059)"*/}
                            {/*    fill="#ffd100"*/}
                            {/*/>*/}

                            {/*<path*/}
                            {/*    id="Path_259"*/}
                            {/*    data-name="Path 259"*/}
                            {/*    d="M1544.246,1061.965a1.294,1.294,0,0,0-1.558-.958L724.807,1255.19a1.293,1.293,0,0,0,.3,2.551,1.377,1.377,0,0,0,.3-.035l817.88-194.184A1.292,1.292,0,0,0,1544.246,1061.965Z"*/}
                            {/*    transform="translate(-564.764 -259.482)"*/}
                            {/*    fill="#ffd100"*/}
                            {/*/>*/}

                            <g
                                id="Group_118"
                                data-name="Group 118"
                                transform="translate(145.269 849.676)"
                            >
                                <path
                                    id="Path_260"
                                    data-name="Path 260"
                                    d="M543.465,1762.445a6.872,6.872,0,0,1-.663-.975l-18.476,13.342a1.293,1.293,0,0,0,1.516,2.094l18.39-13.28a5.016,5.016,0,0,1-.767-1.182Z"
                                    transform="translate(-523.791 -1761.47)"
                                    fill="none"
                                />
                                <path
                                    id="Path_261"
                                    data-name="Path 261"
                                    d="M543.465,1762.445a6.872,6.872,0,0,1-.663-.975l-18.476,13.342a1.293,1.293,0,0,0,1.516,2.094l18.39-13.28a5.016,5.016,0,0,1-.767-1.182Z"
                                    transform="translate(-523.791 -1761.47)"
                                    fill="#ffd100"
                                />
                            </g>

                            <g
                                id="Group_119"
                                data-name="Group 119"
                                transform="translate(151.166 867.12)"
                            >
                                <path
                                    id="Path_262"
                                    data-name="Path 262"
                                    d="M619.721,2015.932c-.024-.254-.037-.558-.044-.872l-9.616,5.187a1.292,1.292,0,1,0,1.23,2.274l8.419-4.541A6.943,6.943,0,0,1,619.721,2015.932Z"
                                    transform="translate(-609.381 -2015.06)"
                                    fill="none"
                                />
                                <path
                                    id="Path_263"
                                    data-name="Path 263"
                                    d="M619.721,2015.932c-.024-.254-.037-.558-.044-.872l-9.616,5.187a1.292,1.292,0,1,0,1.23,2.274l8.419-4.541A6.943,6.943,0,0,1,619.721,2015.932Z"
                                    transform="translate(-609.381 -2015.06)"
                                    fill="#ffd100"
                                />
                            </g>

                        </g>

                        <g
                            id="Group_121"
                            data-name="Group 121"
                            transform="translate(165.491 785.074)"
                        >
                            <path
                                id="Path_264"
                                data-name="Path 264"
                                d="M836.338,1358.973l-.081-.063c-4.96-3.825-8.237-6.353-8.182-10.779.017-3.289,1.705-5.642,4.516-6.294a3.052,3.052,0,0,1,2.737.37c1.093.885,1.591,2.965,1.52,6.36l-.021,1.741a1.566,1.566,0,0,0,.607,1.2,1.629,1.629,0,0,0,1.368.284l5.715-1.326a2.789,2.789,0,0,0,2.05-2.531l-.011-1.961c.06-5.722-1.273-9.717-3.963-11.873-2.361-1.892-5.732-2.346-10.018-1.353-10.605,2.462-14.467,10.9-14.546,17.973-.052,8.949,5.834,13.339,10.135,16.547l.557.406c4.648,3.386,8.321,6.059,8.222,11.212,0,4.47-2.707,6.037-4.983,6.565a3.9,3.9,0,0,1-3.429-.439c-1.047-.841-1.561-2.6-1.529-5.226l.055-3.376a1.886,1.886,0,0,0-.681-1.537,2.055,2.055,0,0,0-1.767-.343l-4.981,1.156a3,3,0,0,0-2.262,2.821l-.042,4.11c-.044,4.531,1.408,8.21,4.088,10.357a10.546,10.546,0,0,0,6.751,2.181,17.352,17.352,0,0,0,3.913-.477,19.131,19.131,0,0,0,14.951-18.724c.01-8.16-4.425-12.186-10.692-16.982Z"
                                transform="translate(-817.326 -1297.161)"
                                fill="#ffd100"
                            />

                            <path
                                id="Path_265"
                                data-name="Path 265"
                                d="M1296.479,1231.85a2.1,2.1,0,0,0-.88-1.47,2.259,2.259,0,0,0-1.808-.31l-7.43,1.724a3.76,3.76,0,0,0-2.666,2.866l-10.162,57.463a1.757,1.757,0,0,0,.493,1.61,1.675,1.675,0,0,0,1.163.447,2.06,2.06,0,0,0,.461-.054l5.3-1.23a3.48,3.48,0,0,0,2.5-2.835l1.474-9.806a.905.905,0,0,1,.712-.749l8.247-1.914a.426.426,0,0,1,.36.064.34.34,0,0,1,.1.3l1.222,9.145a2.044,2.044,0,0,0,.873,1.428,2.39,2.39,0,0,0,1.9.332l5.307-1.232a2.648,2.648,0,0,0,1.934-2.8l-9.1-52.977Zm-3.5,36.405a.3.3,0,0,1-.045.213.773.773,0,0,1-.441.362l-5.633,1.308a.2.2,0,0,1-.19-.038.348.348,0,0,1-.1-.271l3.542-22.416Z"
                                transform="translate(-1242.076 -1201.96)"
                                fill="#ffd100"
                            />

                            <path
                                id="Path_266"
                                data-name="Path 266"
                                d="M1812.709,1105.645l12.981-3.012a3.094,3.094,0,0,0,2.344-2.844v-4.423a1.833,1.833,0,0,0-2.367-1.9l-21.552,5a3.1,3.1,0,0,0-2.347,2.842l-.53,55.224a1.889,1.889,0,0,0,.681,1.538,1.931,1.931,0,0,0,1.219.406,2.409,2.409,0,0,0,.548-.064l5.716-1.327a3,3,0,0,0,2.262-2.82l.256-23.311c-.03-.221.284-.6.552-.657l8.979-2.084a3.1,3.1,0,0,0,2.347-2.843l.007-4.344a1.83,1.83,0,0,0-2.365-1.9l-8.98,2.084a.418.418,0,0,1-.358-.091.261.261,0,0,1-.1-.224l.159-14.533a.888.888,0,0,1,.548-.719Z"
                                transform="translate(-1733.456 -1074.754)"
                                fill="#ffd100"
                            />

                            <path
                                id="Path_267"
                                data-name="Path 267"
                                d="M2185.388,1025.212a2.094,2.094,0,0,0-.88-1.469,2.246,2.246,0,0,0-1.81-.311l-7.429,1.724a3.755,3.755,0,0,0-2.665,2.865l-10.162,57.462a1.757,1.757,0,0,0,.491,1.61,1.676,1.676,0,0,0,1.165.448,2.051,2.051,0,0,0,.46-.054l5.3-1.231a3.484,3.484,0,0,0,2.506-2.834l1.474-9.806a.9.9,0,0,1,.712-.749l8.247-1.914a.428.428,0,0,1,.36.065c.069.057.1.136.1.3l1.222,9.146a2.048,2.048,0,0,0,.874,1.429,2.393,2.393,0,0,0,1.895.331l5.307-1.231a2.649,2.649,0,0,0,1.934-2.8l-9.1-52.977Zm-3.5,36.406a.294.294,0,0,1-.046.213.78.78,0,0,1-.44.362l-5.634,1.308a.2.2,0,0,1-.19-.037.35.35,0,0,1-.105-.272l3.542-22.416,2.873,20.843Z"
                                transform="translate(-2069.748 -1009.535)"
                                fill="#ffd100"
                            />

                            <path
                                id="Path_268"
                                data-name="Path 268"
                                d="M2712.4,940.174c4.868-3.7,6.545-7.969,6.645-16.93.058-7.276-1.148-11.506-3.912-13.715-2.274-1.819-5.558-2.2-10.034-1.158l-13.225,3.069a3.093,3.093,0,0,0-2.344,2.842l-.53,55.224a1.887,1.887,0,0,0,.678,1.538,1.933,1.933,0,0,0,1.221.407,2.408,2.408,0,0,0,.547-.064l5.715-1.326a3,3,0,0,0,2.262-2.82l.2-21.759a1,1,0,0,1,.631-.738l1.879-.436a.488.488,0,0,1,.63.365l5.687,20.495a2.409,2.409,0,0,0,3,1.579l5.469-1.269a2.314,2.314,0,0,0,1.694-2.681l-6.626-21.75c-.137-.265.035-.646.416-.871Zm-3.647-14.936c-.042,7.005-1.294,9.319-5.577,10.313l-3.02.7a.3.3,0,0,1-.269-.064.3.3,0,0,1-.105-.254l.175-17c-.03-.22.284-.594.55-.656l3.022-.7a8.624,8.624,0,0,1,1.913-.26,2.72,2.72,0,0,1,1.769.524c1.122.894,1.569,3.036,1.542,7.392Z"
                                transform="translate(-2560.056 -901.922)"
                                fill="#ffd100"
                            />

                            <path
                                id="Path_269"
                                data-name="Path 269"
                                d="M3208.821,822.7a1.938,1.938,0,0,0-1.686-.322l-5.634,1.308a3.094,3.094,0,0,0-2.344,2.841l-.53,55.224a1.89,1.89,0,0,0,.678,1.538,1.936,1.936,0,0,0,1.22.406,2.408,2.408,0,0,0,.547-.064l5.634-1.308a3,3,0,0,0,2.264-2.821l.53-55.224a1.935,1.935,0,0,0-.68-1.58Z"
                                transform="translate(-3034.578 -822.32)"
                                fill="#ffd100"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}

function Header() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [howToOpen, setHowToOpen] = useState(false);

    const closeMobileMenu = () => {
        setMenuOpen(false);
        setHowToOpen(false);
    };



    const location = useLocation();

    const isActivePage =
        location.pathname.startsWith("/product/") ||
        location.pathname.startsWith("/recipe/");
    return (
        <>
            <div className="desktop-header">

                <div className="header-logo">
                    <SafariLogo />
                </div>

                <nav className={`header-nav ${isActivePage ? "active" : ""}`}>

                    <NavLink to="/">
                        {({ isActive }) => (
                            <>
                                {isActive && (
                                    <svg
                                        id="Layer_1"
                                        data-name="Layer 1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="10"
                                        height="10"
                                        viewBox="0 0 10 10"
                                        className="header-active-icon"
                                    >
                                        <path
                                            id="Path_232"
                                            data-name="Path 232"
                                            d="M6.109,3.595,9.372,2.541,10,4.72,6.737,5.773,8.709,8.7,6.9,10,4.958,7.074,2.915,9.926,1.156,8.562,3.225,5.71,0,4.54.7,2.386,3.926,3.555,3.987,0l2.18.04Z"
                                            fill="#1a1a1a"
                                        />
                                    </svg>
                                )}
                                <span>HOME</span>
                            </>
                        )}
                    </NavLink>

                    <NavLink to="/about-us">
                        {({ isActive }) => (
                            <>
                                {isActive && (
                                    <svg
                                        id="Layer_1"
                                        data-name="Layer 1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="10"
                                        height="10"
                                        viewBox="0 0 10 10"
                                        className="header-active-icon"
                                    >
                                        <path
                                            id="Path_232"
                                            data-name="Path 232"
                                            d="M6.109,3.595,9.372,2.541,10,4.72,6.737,5.773,8.709,8.7,6.9,10,4.958,7.074,2.915,9.926,1.156,8.562,3.225,5.71,0,4.54.7,2.386,3.926,3.555,3.987,0l2.18.04Z"
                                            fill="#1a1a1a"
                                        />
                                    </svg>
                                )}
                                <span>ABOUT</span>
                            </>
                        )}
                    </NavLink>

                    <NavLink
                        to="/products"
                        className={({ isActive }) =>
                            isActive || location.pathname.startsWith("/product/")
                                ? "active"
                                : ""
                        }
                    >
                        {({ isActive }) => {
                            const productsActive =
                                isActive ||
                                location.pathname.startsWith("/product/");

                            return (
                                <>
                                    {productsActive && (
                                        <svg
                                            id="Layer_1"
                                            data-name="Layer 1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="10"
                                            height="10"
                                            viewBox="0 0 10 10"
                                            className="header-active-icon"
                                        >
                                            <path
                                                id="Path_232"
                                                data-name="Path 232"
                                                d="M6.109,3.595,9.372,2.541,10,4.72,6.737,5.773,8.709,8.7,6.9,10,4.958,7.074,2.915,9.926,1.156,8.562,3.225,5.71,0,4.54.7,2.386,3.926,3.555,3.987,0l2.18.04Z"
                                                fill="#1a1a1a"
                                            />
                                        </svg>
                                    )}

                                    <span>PRODUCTS</span>
                                </>
                            );
                        }}
                    </NavLink>

                    <div className="header-dropdown">

                        <NavLink to="/how-to">
                            {({ isActive }) => (
                                <>
                                    {isActive && (
                                        <svg
                                            width="10"
                                            height="10"
                                            viewBox="0 0 10 10"
                                            className="header-active-icon"
                                        >
                                            <path
                                                d="M6.109,3.595,9.372,2.541,10,4.72,6.737,5.773,8.709,8.7,6.9,10,4.958,7.074,2.915,9.926,1.156,8.562,3.225,5.71,0,4.54.7,2.386,3.926,3.555,3.987,0l2.18.04Z"
                                                fill="#1a1a1a"
                                            />
                                        </svg>
                                    )}

                                    <span>HOW TO</span>
                                </>
                            )}
                        </NavLink>

                        <div className="header-dropdown-menu">


                            <NavLink to="/how-to/cooking">
                                COOKING
                            </NavLink>

                            <NavLink to="/how-to/cleaning">
                                CLEANING
                            </NavLink>

                            <NavLink to="/how-to/health">
                                HEALTH
                            </NavLink>
                        </div>

                    </div>

                    <NavLink
                        to="/recipes"
                        className={({ isActive }) =>
                            isActive || location.pathname.startsWith("/recipe/")
                                ? "active"
                                : ""
                        }
                    >
                        {({ isActive }) => {
                            const recipesActive =
                                isActive ||
                                location.pathname.startsWith("/recipe/");

                            return (
                                <>
                                    {recipesActive && (
                                        <svg
                                            id="Layer_1"
                                            data-name="Layer 1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="10"
                                            height="10"
                                            viewBox="0 0 10 10"
                                            className="header-active-icon"
                                        >
                                            <path
                                                id="Path_232"
                                                data-name="Path 232"
                                                d="M6.109,3.595,9.372,2.541,10,4.72,6.737,5.773,8.709,8.7,6.9,10,4.958,7.074,2.915,9.926,1.156,8.562,3.225,5.71,0,4.54.7,2.386,3.926,3.555,3.987,0l2.18.04Z"
                                                fill="#1a1a1a"
                                            />
                                        </svg>
                                    )}

                                    <span>RECIPES</span>
                                </>
                            );
                        }}
                    </NavLink>

                    <NavLink
                        to="/news"
                        className={({ isActive }) =>
                            isActive || location.pathname.startsWith("/blog/")
                                ? "active"
                                : ""
                        }
                    >
                        {({ isActive }) => {
                            const newsActive =
                                isActive ||
                                location.pathname.startsWith("/blog/");

                            return (
                                <>
                                    {newsActive && (
                                        <svg
                                            id="Layer_1"
                                            data-name="Layer 1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="10"
                                            height="10"
                                            viewBox="0 0 10 10"
                                            className="header-active-icon"
                                        >
                                            <path
                                                id="Path_232"
                                                data-name="Path 232"
                                                d="M6.109,3.595,9.372,2.541,10,4.72,6.737,5.773,8.709,8.7,6.9,10,4.958,7.074,2.915,9.926,1.156,8.562,3.225,5.71,0,4.54.7,2.386,3.926,3.555,3.987,0l2.18.04Z"
                                                fill="#1a1a1a"
                                            />
                                        </svg>
                                    )}

                                    <span>NEWS</span>
                                </>
                            );
                        }}
                    </NavLink>

                    <NavLink to="/contact-us">
                        {({ isActive }) => (
                            <>
                                {isActive && (
                                    <svg
                                        id="Layer_1"
                                        data-name="Layer 1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="10"
                                        height="10"
                                        viewBox="0 0 10 10"
                                        className="header-active-icon"
                                    >
                                        <path
                                            id="Path_232"
                                            data-name="Path 232"
                                            d="M6.109,3.595,9.372,2.541,10,4.72,6.737,5.773,8.709,8.7,6.9,10,4.958,7.074,2.915,9.926,1.156,8.562,3.225,5.71,0,4.54.7,2.386,3.926,3.555,3.987,0l2.18.04Z"
                                            fill="#1a1a1a"
                                        />
                                    </svg>
                                )}
                                <span>CONTACT US</span>
                            </>
                        )}
                    </NavLink>

                </nav>
            </div>

            <div className={`mobile-header ${menuOpen ? "menu-open" : ""}`}>

                <div className="mobile-header-top">

                    <NavLink
                        to="/"
                        className="mobile-logo"
                        onClick={closeMobileMenu}
                    >
                        <SafariLogo />
                    </NavLink>

                    <button
                        type="button"
                        className={`mobile-menu-button ${menuOpen ? "active" : ""}`}
                        onClick={() => setMenuOpen(!menuOpen)}
                        aria-label={menuOpen ? "Close menu" : "Open menu"}
                        aria-expanded={menuOpen}
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>

                </div>

                {menuOpen && (
                    <nav className="mobile-nav">

                        <NavLink
                            to="/"
                            onClick={closeMobileMenu}
                        >
                            HOME
                        </NavLink>

                        <NavLink
                            to="/about-us"
                            onClick={closeMobileMenu}
                        >
                            ABOUT
                        </NavLink>

                        <NavLink
                            to="/products"
                            onClick={closeMobileMenu}
                        >
                            PRODUCTS
                        </NavLink>

                        <div className="mobile-dropdown">

                            <button
                                type="button"
                                className="mobile-dropdown-toggle"
                                onClick={() => setHowToOpen(!howToOpen)}
                            >
                                <span>HOW TO</span>

                                <span
                                    className={`mobile-dropdown-icon ${
                                        howToOpen ? "open" : ""
                                    }`}
                                >
                                    +
                                </span>
                            </button>

                            {howToOpen && (
                                <div className="mobile-dropdown-menu">



                                    <NavLink
                                        to="/how-to/cooking"
                                        onClick={closeMobileMenu}
                                    >
                                        COOKING
                                    </NavLink>

                                    <NavLink
                                        to="/how-to/cleaning"
                                        onClick={closeMobileMenu}
                                    >
                                        CLEANING
                                    </NavLink>

                                    <NavLink
                                        to="/how-to/health"
                                        onClick={closeMobileMenu}
                                    >
                                        HEALTH
                                    </NavLink>

                                </div>
                            )}

                        </div>

                        <NavLink
                            to="/recipes"
                            onClick={closeMobileMenu}
                        >
                            RECIPES
                        </NavLink>

                        <NavLink
                            to="/news"
                            onClick={closeMobileMenu}
                        >
                            NEWS
                        </NavLink>

                        <NavLink
                            to="/contact-us"
                            onClick={closeMobileMenu}
                        >
                            CONTACT US
                        </NavLink>

                    </nav>
                )}

            </div>
        </>
    );
}

export default Header;
